import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

export const login = createAsyncThunk(
    "auth/login",
    async({ email, password }, thunkAPI) => {
        try {
            const data = await AuthService.login({ email, password });
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});


export const GetClientsDetail = createAsyncThunk(
    "auth/getclientsdetail",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.GetClientsDetail(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});


export const CheckProfile = createAsyncThunk(
    "auth/checkprofile",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.CheckProfile(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const UpdateLoginPassword = createAsyncThunk(
    "auth/UpdateLogin",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.UpdateLogin(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const SendOtp = createAsyncThunk(
    "auth/sendOtp",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.SendOtp(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const VerifyOtpUpdatePassword = createAsyncThunk(
    "auth/verifyOtpUpdatePassword",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.VerifyOtpUpdatePassword(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const Adduser = createAsyncThunk(
    "auth/adduser",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.AddUser(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});


export const Listuser = createAsyncThunk(
    "auth/listuser",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.ListUser(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const UserDetail = createAsyncThunk(
    "auth/userdetail",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.UserDetail(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});

export const UsersUpdate = createAsyncThunk(
    "auth/UsersUpdate",
    async(item, thunkAPI) => {
        try {
            const data = await AuthService.UsersUpdate(item);
            return { user: data };
        } catch (error) {
            const message = 
            (error.response &&
                error.response.data &&
                error.response.data.messages &&
                error.response.data.messages.error) || 
            error.message ||
            error.toString();

        return thunkAPI.rejectWithValue({ message })
    }
});






const initialState = {
    loading: false,
    error: "",
    user: null,
    isLoggedIn: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = "";
                state.isLoggedIn = false;
                state.user = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.error = "";
                state.isLoggedIn = true;
                state.user = action.payload.user;  // Ensure this is a plain object
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload.message;
                state.isLoggedIn = false;
                state.user = null;
            });
    }
});


const { reducer } = authSlice;
export default reducer;